export function Barriers() {
  return (
    <div className="p-4 space-y-6">
      <header className="pt-2">
        <h1 className="text-2xl font-bold">Barriers</h1>
        <p className="text-white/50 text-sm">What's stopping you — and how to remove it</p>
      </header>

      <section className="card">
        <div className="text-center py-8">
          <span className="text-4xl mb-4 block">⚡</span>
          <h3 className="text-lg font-medium mb-2">No barriers detected yet</h3>
          <p className="text-white/50 text-sm">
            As you use WholeWorm, we'll identify patterns that are blocking your progress
          </p>
        </div>
      </section>
    </div>
  );
}
